module.exports = __webpack_public_path__ + "static/media/guardSoldier.9d25bc4a.png";